import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { LibFormValidityDotComponent, LorenzFormGroup, LorenzFormGroupComponent } from '@lib/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppService } from '../../app.service';
import { LibSharedButtonComponent } from '@lib/shared';
import { take } from 'rxjs';

@Component({
	selector: 'request-request',
	standalone: true,
	imports: [AsyncPipe, LorenzFormGroupComponent, TranslateModule, LibFormValidityDotComponent, LibSharedButtonComponent],
	templateUrl: './request.component.html',
	styleUrl: './request.component.scss'
})
export class RequestComponent {
	readonly appService = inject(AppService);

	get requestForm() {
		return this.appService.requestForm;
	}

	retry(): void {
		this.appService.retryRequestForm();
	}

	// FOR DEBUG
	// requestForm = this.appService.requestForm.pipe(
	// 	tap((response) => {
	// 		console.log('RequestComponent', response);
	// 	})
	// );

	submitForm(requestForm: LorenzFormGroup, callMe: boolean) {
		if (requestForm.valid) {
			// this.appService.getControl('_lorenz.rueckruf')?.setValue(callMe);
			this.appService.getControl('_lorenz.sprache')?.setValue(this.appService.getCurrentLanguage());

			console.log('DEBUG', 'POST FORM Request', requestForm.getRawValue());

			this.appService.storeRequestData(requestForm).pipe(take(1)).subscribe();
		}
	}
}
